import Config from '../../config';
let config;
import { captureException, captureMessage } from 'lib/common/logger';

export function redirectWithMessage(msg, url) {
  config = new Config().getConfig();
  config = new Config().getConfig();
  msg = msg || config.fallbacks.defaultMessage;
  url = url || config.fallbacks.fallbackUrl;
  window.location = url;

  return false;
}

export function redirectWithError(err) {
  if (err) {
    captureException(err);
  }
  //redirectWithMessage(msg, url);
}

export function redirectWithLog(logMsg, msg, url) {
  if (logMsg) {
    captureMessage(logMsg);
  }
  redirectWithMessage(msg, url);
}

export default {
  redirectWithMessage,
  redirectWithError,
  redirectWithLog
};



// WEBPACK FOOTER //
// ./src/javascripts/lib/common/fallbacks.js